import React, { useState } from 'react';
import "./styles.css";




const ToggleCustom = ({isChecked,setChecked,display}) => {


  function getTextWidth(disp) { 
  
    let text = document.createElement("span"); 
    document.body.appendChild(text); 

    // text.style.font = "times new roman"; 
    text.style.fontSize = 12 + "px"; 
    text.style.height = 'auto'; 
    text.style.width = 'auto'; 
    text.style.position = 'absolute'; 
    text.style.whiteSpace = 'no-wrap'; 
    text.innerHTML = disp; 

    let width = Math.ceil(text.clientWidth); 
    let formattedWidth = width;
    document.body.removeChild(text); 
    return width;
}


  const handleToggle=(r)=>{
    setChecked(r);
  }
  
  let wdth=getTextWidth(display);
  let st=isChecked ? {left:wdth ? wdth+9 : 2} : {left:2};

  return (
    <div style={{padding:"0px 10px"}}>
      <label className="switch" >
        <input className="toggle-input" type="checkbox" value={isChecked} onChange={(e)=>handleToggle(e.target.checked)} />
        <div className="toggle-circle hand" style={st}></div>
        <div className={`toggle-slider ${isChecked ? 'rightpad' :'leftpad' }`}>{display}</div>
      </label>
    </div>
  );
}


export default ToggleCustom;